import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { Link } from "react-router-dom";
import { getArticlesById } from "services/article_service";
import TopAdd from "components/TopAdd";
import Topnav from "components/Topnav";

function App() {
  const { t } = useTranslation();
  const [article, setArticle] = useState({
    attributes: { title: "", content: "" },
  });

  useEffect(() => {
    async function getArtsById() {
      try {
        const urlSplit = window.location.href.split("/");

        const article = await getArticlesById(urlSplit[urlSplit.length - 1]);
        setArticle(article);
      } catch (exception) {
        console.log("exception: ", exception);
      }
    }

    getArtsById();
  }, []);

  return (
    <div className="geral">
      <div className="App">
        <Topnav></Topnav>
        <div className="conteudo">
          <TopAdd></TopAdd>
          <section className="section">

          <nav className="breadcrumb" aria-label="breadcrumbs">
              <ul>
                <li>
                    <Link to={"/artigos"} >
                      {t("articles")}
                    </Link>
                  </li>
                  <li className="is-active">
                    <Link>
                      {article.attributes.title}
                    </Link>
                  </li>
               </ul>
            </nav>

             <div className="hero is-footsolution">
                <div className="columns">
                  <div className="column">
                    <h1 className="title is-3">Artigo</h1>
                  </div>
                </div>
              </div>

            <div className="columns">
              <div className="column is-9">
                <div className="box-footsolution">

                
                  <div className="hero-body" style={{ padding: "3em 0em" }}>
                    <p className="title">{article.attributes.title}</p>
                  </div>
                

                
                  <div className="content">{article.attributes.content}</div>
                

                
                  <div className="buttons has-addons is-centered">
                    <Link to={"/artigos"}>
                      {" "}
                      <button className="button btn1">
                        {t("back_to_article")}
                      </button>{" "}
                    </Link>
                  </div>
                
              </div>
              </div>
              <div className="column">
                <div className="box-footsolution extra">
                  <h2 className="title is-5">Artigos relacionados</h2>
                    <ul>
              {/* eslint-disable jsx-a11y/anchor-is-valid */}
                      <li><a href="">Artigo relacionado 1</a></li>
              {/* eslint-disable jsx-a11y/anchor-is-valid */}


                    <li><a href="">Artigo relacionado 2</a></li>
              {/* eslint-disable jsx-a11y/anchor-is-valid */}

                    <li><a href="">Artigo relacionado 2</a></li>
                    </ul>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
export default App;
